import { render } from "./OperacionesActivos.vue?vue&type=template&id=207bf63c"
import script from "./OperacionesActivos.vue?vue&type=script&lang=js"
export * from "./OperacionesActivos.vue?vue&type=script&lang=js"

import "./OperacionesActivos.vue?vue&type=style&index=0&id=207bf63c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__